import React, { useEffect, useState } from 'react';
import { styled } from '@mui/material/styles';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import { PRIMARY_COLOR, SECONDARY_COLOR } from '../../styles/colors';
import { ListItem, ListItemIcon, ListItemText, ListItemButton } from '@mui/material';
import { Link, useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import { getPrivilegeStatus } from '../../util';
import { useHistory } from 'react-router-dom';

const MUIAccordion = styled((props) => <MuiAccordion disableGutters elevation={0} square {...props} />)(({ theme }) => ({}));

const AccordionSummary = styled((props) => <MuiAccordionSummary expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: '0.9rem', color: props.active ? '#fff' : '#000' }} />} {...props} />)(
    ({ theme, ...props }) => ({
        backgroundColor: props.active ? PRIMARY_COLOR : 'transparent',
        color: props.active ? '#fff' : '#000',
        borderRadius: '10px !important',
        flexDirection: 'row',
        alignItems: 'center',
        padding: '0 7px 0 5px',
        '& .MuiAccordionSummary-expandIconWrapper': {
            display: props.links == 0 ? 'none' : 'flex',
        },
        '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
            transform: 'rotate(90deg)',
        },
        '& .MuiAccordionSummary-content': {
            marginLeft: theme.spacing(1),
        },
    })
);

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
    padding: '0 0 0 15px',
    borderTop: '1px solid rgba(0, 0, 0, .125)',
}));

const MenuAccordion = ({ link, active = false, user, open }) => {
    const location = useLocation();
    const history = useHistory();
    const [expanded, setExpanded] = useState(active);

    const togglePanel = () => () => {
        setExpanded(!expanded);
    };

    const getActiveLink = (link) => {
        return Boolean(location.pathname.toLowerCase() === link.toLowerCase());
    };

    return (
        <div onClick={() => (!open || !(link?.subMenus?.length > 0)) && history.push(link.path)} title={link.title} style={{ cursor: 'pointer' }} className="menu-item">
            {!open
                ? Boolean(getPrivilegeStatus(link?.id) || link?.id === '') && <div className={active ? 'menu-close-icons active' : 'menu-close-icons'}>{link.icon}</div>
                : Boolean(getPrivilegeStatus(link?.id) || link?.id === '') && (
                      <MUIAccordion expanded={expanded} onChange={togglePanel()}>
                          <AccordionSummary active={active} links={link?.subMenus?.length || 0} style={{ borderRadius: 10, borderBottom: 'none' }}>
                              {link.icon} <Typography fontSize={12}>{link.title}</Typography>
                          </AccordionSummary>
                          {link?.subMenus?.length > 0 && (
                              <AccordionDetails>
                                  {link.subMenus.map(
                                      (lnk, key) =>
                                          Boolean(getPrivilegeStatus(lnk?.id) || link?.id === '') && (
                                              <Link to={`${lnk.path}`} key={key}>
                                                  <ListItemButton button key={key} style={{ padding: '5px', color: getActiveLink(lnk.path) ? PRIMARY_COLOR : SECONDARY_COLOR }}>
                                                      <ListItemIcon style={{ minWidth: 'auto', marginRight: '.5rem', color: 'inherit' }}>{lnk.icon}</ListItemIcon>
                                                      <ListItemText primary={lnk.title} primaryTypographyProps={{ fontSize: 12 }} />
                                                  </ListItemButton>
                                              </Link>
                                          )
                                  )}
                              </AccordionDetails>
                          )}
                      </MUIAccordion>
                  )}
        </div>
    );
};

const mapStateToProps = ({ user }) => ({ user });

export default connect(mapStateToProps, null)(MenuAccordion);
